
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c6668afe!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RepositorioCadeia.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RepositorioCadeia.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-c6668afe!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RepositorioCadeia.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RepositorioCadeia.vue
// module id = 84
// module chunks = 0